import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as selectionAction from "store/ui/selections/action";


const useMultiSelect = () => {
    const dispatch = useDispatch();
    const { selections: savedSelections } = useSelector((s) => s.ui.selections);
    const [selections, setSelections] = useState(savedSelections);
    

    const toggleMultiSelectHeader = () => {
        const selectionHead = document.querySelector(".multi-select-header");
        if (selectionHead.checked === true){
            toggleSelectAll(true);
        }
        else{
            toggleSelectAll(false);
        }
    }


    const toggleSelectAll = (action) => {
        const selectionsBody = document.querySelectorAll(".multi-select");
        if (selectionsBody?.length > 0){
            selectionsBody.forEach((selectionBody) => {
                if (!selectionBody.disabled) {
                    selectionBody.checked = action;
                }
            });
            getMultiSelectBody();
        }
    }


    const checkMultiSelectHeader = () => {
        const selectionHead = document.querySelector(".multi-select-header");
        const selectionsBody = document.querySelectorAll(".multi-select");
        let deselections = 0;

        selectionsBody.forEach((selection) => {
            if (selection.checked !== true){
                deselections++;
            }
        });

        if (deselections === 0){
            selectionHead.checked = true;
        }
        else{
            selectionHead.checked = false;
        }
    }


    const getMultiSelectBody = () => {
        checkMultiSelectHeader();
        const selectionsBody = document.querySelectorAll(".multi-select");
        let selectionsCopy = [...selections];
        selectionsBody.forEach((selection) => {
            if (selection.checked === true){
                // if (!selectionsCopy.includes(selection.value)){
                if (selectionsCopy.filter(item => item === selection.value).length === 0){
                    selectionsCopy.push(selection.value);
                }
            }
            else{
                selectionsCopy = selectionsCopy.filter(item => item !== selection.value);
            }
        });
        setSelections(selectionsCopy);
    }
    
    
    const removeFromSelections = (data) => {
        if (data.length > 0){
            const newSelection = selections.filter((item) => !data.includes(item));
            setSelections(newSelection);
        }
    }


    const clearSelections = () => {
        toggleSelectAll(false);
        setSelections([]);
        
        // document.querySelector(".multi-select-header").checked = false;
        const selectionHeader = document.querySelector(".multi-select-header");
        if (selectionHeader){
            selectionHeader.checked = false;
        }
    }


    useEffect(() => {
        dispatch(selectionAction.saveSelection(selections));
        // eslint-disable-next-line
    }, [selections]);


    return {selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections, removeFromSelections, toggleSelectAll};
}


export default useMultiSelect;
